export const CARD_FLEX_CLASS = "text-center mx-auto lg:mx-[13px]";

export const DESCRIPTION = "mt-[12px] md:mt-[20px] text-center pb-[28px]";
